import { InternalAxiosRequestConfig } from 'axios'
import { IRequestMiddleware } from './types'

export default class JsonPatchMiddleware implements IRequestMiddleware {
  private readonly useJsonPatchHeader: boolean

  constructor(useJsonPatchHeader: boolean) {
    this.useJsonPatchHeader = useJsonPatchHeader
  }

  public handle(requestConfig: InternalAxiosRequestConfig): InternalAxiosRequestConfig {
    if (!this.useJsonPatchHeader) return requestConfig

    const isPatchRequest = requestConfig.method === 'patch'

    if (isPatchRequest) requestConfig.headers['Content-Type'] = 'application/json-patch+json'

    return requestConfig
  }
}
